import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5c70c088&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5c70c088&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c70c088",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c70c088')) {
      api.createRecord('5c70c088', component.options)
    } else {
      api.reload('5c70c088', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5c70c088&scoped=true", function () {
      api.rerender('5c70c088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/technology/FinancialTextReview/index.vue"
export default component.exports